import { render, staticRenderFns } from "./ed-presentation-mode-users.component.vue?vue&type=template&id=2c5db41a&scoped=true&"
import script from "./ed-presentation-mode-users.component.ts?vue&type=script&lang=ts&"
export * from "./ed-presentation-mode-users.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-presentation-mode-users.component.scss?vue&type=style&index=0&id=2c5db41a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5db41a",
  null
  
)

export default component.exports